import api from './client'

/**
 * ثبتِ «باز کردنِ قرارداد» — شمارندهٔ بازدید (برای گزارشِ ادمین).
 * شکستِ این درخواست هرگز نباید تجربهٔ کاربر را خراب کند.
 */
export const trackContractOpen = (contractId) => {
  if (!contractId) return Promise.resolve(null)
  try {
    return api.post(`contracts/${contractId}/open/`).catch(() => null)
  } catch (e) {
    return Promise.resolve(null)
  }
}
